export async function withRequestTimeout(timeoutMs, request, timeoutError) {
    const timeout = createRequestTimeout(timeoutMs);
    try {
        return await request(timeout?.signal);
    }
    catch (error) {
        if (timeout?.expired && isAbortError(error)) {
            throw timeoutError();
        }
        throw error;
    }
    finally {
        timeout?.clear();
    }
}
function createRequestTimeout(timeoutMs) {
    if (timeoutMs <= 0)
        return null;
    const controller = new AbortController();
    let expired = false;
    const timer = setTimeout(() => {
        expired = true;
        controller.abort();
    }, timeoutMs);
    return {
        signal: controller.signal,
        get expired() {
            return expired;
        },
        clear() {
            clearTimeout(timer);
        },
    };
}
function isAbortError(error) {
    return error instanceof Error && error.name === "AbortError";
}
export function normalizeBaseUrl(baseUrl) {
    const trimmed = baseUrl.trim();
    return trimmed === "" ? "" : trimmed.replace(/\/+$/, "");
}
export async function readResponseBody(response) {
    const text = await response.text();
    if (!text)
        return null;
    try {
        return JSON.parse(text);
    }
    catch {
        return text;
    }
}
export function messageFromResponseBody(body) {
    if (typeof body === "object" && body !== null && "message" in body) {
        const message = body.message;
        if (typeof message === "string")
            return message;
        if (Array.isArray(message))
            return message.join(", ");
    }
    return null;
}
//# sourceMappingURL=http.js.map